module.exports = __webpack_public_path__ + "media/bg/bg-2-d84b02f7.jpg";